export const styles = {
  wrapper: {
    width: "391px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    position: "relative",

    "&:focus-within svg": {
      color: "#383C40",
    },

    "& svg": {
      color: "#C6CACE",
    },
  },
  label: {
    height: "24px",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    color: "#292929",
  },
  inputProps: {
    sx: {
      height: "50px",
      width: "100%",
      caretColor: "#5b87f8",
      borderRadius: "3.125rem",
      fontSize: "1rem",
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D6D6D6",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D6D6D6",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#5b87f8",
      },
      "& .MuiInputBase-input": {
        color: "#383C40",
        padding: "0 1rem",
        height: "100%",
        boxSizing: "border-box",
      },
      "& input:-webkit-autofill": {
        boxShadow: "0 0 0 1000px #fff inset",
        WebkitTextFillColor: "#383C40",
      },
    },
  },
  passwordAdornmentBox: {
    width: 22,
    height: 22,
    sx: { cursor: "pointer" },
  },
};
